import React from 'react';
import { Row, Col, Typography, Button } from 'antd';
import { Link } from 'react-router-dom';
import '../../Styles/HomeStyles.css';

const { Title, Paragraph } = Typography;

const GlanceComponent = () => {
  return (
    <section className="glance-section">
      <div className="home-section-shell">
        <Row gutter={[48, 40]} justify="space-between" align="middle">
          <Col xs={24} md={13} lg={14}>
            <Title level={2} className="glance-title">NCGSA at a Glance</Title>
            <div className="section-underline" aria-hidden="true"></div>
            <Paragraph className="glance-description">
            National Center of GIS and Space Applications is one of the five major initiatives of Higher Education 
            Commission (HEC) of Pakistan towards developing capabilities in the emerging technologies. The center 
            comprises of 7 state-of-the-art research labs in 7 partner higher education institutes of Pakistan. NCGSA 
            encompasses endeavors that strive to achieve and sustain human, technological, research and entrepreneurial 
            capacity in the areas of space science, technology and its applications.
          </Paragraph>
            <Button type="primary" size="large" className="glance-button">
              <Link to="/about">About NCGSA</Link>
            </Button>
          </Col>
          
          <Col xs={24} md={11} lg={10}>
            <div className="glance-video">
              <iframe src="https://www.youtube.com/embed/fbXRX0c7EZU" title="National Center of GIS and Space Applications overview" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default GlanceComponent;
